import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemInfoConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ItemInfoConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(ItemInfoConfig, v);
            }
        );
    }

    constructor() {
        super();

        this._rewardInfo = false;
    }

    get rewardInfo() {
        return this._rewardInfo;
    }

    set rewardInfo(value) {
        this._rewardInfo = value;
    }

    valid() {
        return true;
    }

    empty() {
        return !this.rewardInfo;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemInfoConfig());
        } else if (target instanceof ItemInfoConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemInfoConfig, {
    _rewardInfo: alias("reward_info", Schema.primitive())
});